import React, { FC, ReactElement, useState } from 'react'

import { colors } from 'Config/colors'

export interface TabProps {
  name: string
  title: string
  renderContent: ReactElement | ReactElement[]
}

export interface TabSwitcherProps {
  onTabSwitch?: (tabName: string) => void
  tabs: TabProps[]
  activeTab?: string
  part?: 'all' | 'tabs' | 'content'
}

const TabSwitcher: FC<TabSwitcherProps> = ({ tabs, onTabSwitch, activeTab, part = 'all' }) => {
  const [internalTab, setInternalTab] = useState(tabs[0].name)
  const currentTab = activeTab ?? internalTab

  const handleTabSwitch = (tabName: string): void => {
    if (activeTab === undefined) {
      setInternalTab(tabName)
    }
    onTabSwitch && onTabSwitch(tabName)
  }

  const tabButtons = (
    <div className="d-flex">
      {tabs.map((tab) => (
        <div
          key={tab.name}
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => handleTabSwitch(tab.name)}
          className={'text-gray-1 col-12 col-lg-6 pb-1 d-flex justify-content-center'}
          style={{
            cursor: 'pointer',
            borderBottomWidth: currentTab === tab.name ? '4px' : '1px',
            borderColor: currentTab === tab.name ? colors.designSystem.blue2 : colors.designSystem.gray2,
            borderBottomStyle: 'solid'
          }}
        >
          {tab.title}
        </div>
      ))}
    </div>
  )

  const tabContent = tabs.find((tab) => currentTab === tab.name)?.renderContent

  if (part === 'tabs') {
    return tabButtons
  }

  if (part === 'content') {
    return <>{tabContent}</>
  }

  return (
    <>
      {tabButtons}
      {tabContent}
    </>
  )
}

export default TabSwitcher
